<template>
  <div class="row">
    <div class="col-12 col-md-8 col-lg-12">
      <div class="configurator__label">
        {{ $t('request_quotation.title') }}
      </div>
      <div class="u-color--darkgrey pt-2">{{ $t('request_quotation.info') }}</div>
    </div>
    <div class="col-12 col-md-6 col-lg-8" @change="formChange">
      <v-text-field
        v-model="senderName"
        :label="$t('request_quotation.enter_name')"
        :placeholder="$t('request_quotation.name')"
        class="onex-form"
      ></v-text-field>
      <v-text-field
        v-model="senderCompany"
        :label="$t('request_quotation.enter_company')"
        :placeholder="$t('request_quotation.company')"
        class="onex-form"
      ></v-text-field>
      <label class="onex-form label-select">
        {{ $t('request_quotation.enter_country') }}
      </label>
      <v-select
        v-model="selectedCountry"
        :items="countries"
        @change="onRequestQuotationSelect(selectedCountry)"
        :label="$t('request_quotation.country')"
        class="onex-form select"
        single-line
      ></v-select>
      <v-text-field
        v-model="senderMail"
        :label="$t('request_quotation.enter_email')"
        :placeholder="$t('request_quotation.email')"
        class="onex-form"
      ></v-text-field>
      <v-text-field
        v-model="senderPhone"
        :label="$t('request_quotation.enter_phone')"
        :placeholder="$t('request_quotation.phone')"
        class="onex-form"
      ></v-text-field>
    </div>

    <div class="col-12">
      <small>{{ $t('request_quotation.disclaimer') }}</small>
      <div class="actions">
        <button
        class="btn btn--primary"
        :disabled="!senderName || !senderCompany || !selectedCountry || !senderMail"
        @click="sendMail"
        >{{ $t('request_quotation.label') }}</button>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import './../sass/main.scss';
.onex-form {
  font-size: $font-size-xs !important;
}
.actions {
  @include gutter(margin-top, md);
}
</style>

<script>
import countryresponsibles from "../assets/countryresponsibles.json";
import axios from "axios";
import TrackingHelper from "../helpers/TrackingHelper";

export default {
  props: [
    "systems",
    "accessoires"
  ],
  data() {
    return {
      //components: this.$store.getters.bestSystem.components[0],
      selectedCountry: "",
      countries: [],
      requestQuotationList: countryresponsibles,
      selectedRequestor: "",
      senderMail: "",
      senderName: "",
      senderPhone: "",
      senderCompany: "",
      showNotification: false,
      notificationText: "",
    };
  },
  mounted() {
    // Get list of countries
    for (var j = 0; j < this.requestQuotationList.length; j++) {
      if (this.requestQuotationList.country != "") {
        this.countries.push(this.requestQuotationList[j].country);
      }
    }
  },
  methods: {
    formChange: function () {
      if(!this.initalFormEventSent){
        if (this.$store.getters.onlineTrackingEnabled) TrackingHelper.formTracking('start');
        this.initalFormEventSent = true;
      }
    },
    displayConfiguration: function () {

      let selectedAccessoires = this.accessoires.accessoires.filter((acc) => acc.amount > 0);
      selectedAccessoires = selectedAccessoires.concat(this.$store.getters.computedAccessoires.posts.filter((acc) => acc.amount > 0))
      let accessoiresString = `Accessoires:<ul>`;
      for (var m = 0; m < selectedAccessoires.length; m++) {
        accessoiresString =
          accessoiresString +
          `<li>Name: ${selectedAccessoires[m].name}<ul>Article Number: ${selectedAccessoires[m].SAP_Code}<br />Amount: ${selectedAccessoires[m].amount}</ul></li>`;
      }
      accessoiresString = accessoiresString + "</ul>";

      let selectedLights = [];
      let lightsString = `Lights:`;

      if (this.accessoires.lighting != undefined) {
        selectedLights = selectedLights.concat(this.accessoires.lighting.filter((acc) => acc.amount > 0))
      }

      for (var n = 0; n < selectedLights.length; n++) {
        lightsString =
          lightsString +
          `<ul><li>Name: ${selectedLights[n].name}<ul>Article Number: ${selectedLights[n].SAP_Code}<br />Amount: ${selectedLights[n].amount}</li></ul></ul>`;
      }

      let systemComponents = "";
      let selectedSystems = this.systems.filter((acc) => acc.amount > 0);
      for (var o = 0; o < selectedSystems.length; o++) {
        systemComponents =
          systemComponents +
          `<p>Description: ${selectedSystems[o].Description}<br />Width: ${selectedSystems[o].Width}<br />Height: ${selectedSystems[o].Height}<br />Type: ${selectedSystems[o].Type}<br />Subseries: ${selectedSystems[o].Subseries}<br />Temperature: ${selectedSystems.Temperature}<br />Doortype: ${selectedSystems.Doortype}<br />Series: ${selectedSystems.Series}<br />Color: ${selectedSystems[o].Color}<br />Article number: ${selectedSystems[o]["Article number"]}<br />Amount: ${selectedSystems[o].amount}<br />Doors: ${selectedSystems[o].doors}</p>`;
      }

      return `<ul>Coldroom: ${this.$store.getters.coldroom}<br />Cold Room System: ${this.$store.getters.coldroomSystem}<br />Built-in height in mm: ${this.$store.getters.suggestedHeight}<br />Color: ${this.$store.getters.color}<br />Chosen Systems: ${this.$store.getters.numberOfSystems}<br /><br />Components:<ul>${systemComponents}</ul>${accessoiresString}${lightsString}</ul>`;

    },
    onRequestQuotationSelect: function(selectedValue) {
      for (var i = 0; i < this.requestQuotationList.length; i++) {
        if (this.requestQuotationList[i].country == selectedValue) {
          this.selectedRequestor = this.requestQuotationList[i].mail;
        }
      }
    },
    async generateMail() {
      try {
        let headers = {
          headers: {
            ["country"]: this.selectedCountry,
          },
        };

        /* eslint-disable no-console */
        console.log("DisplayConfiguration: " + JSON.stringify(this.displayConfiguration()));

        let payload = `<div><p>Hello,</p> <p>please make an offer for the following configuration.</p><p>To answer this request quotation, please do <b>not</b> reply to this email, but contact ${this.senderName} directly:</p><p><ul>Name: ${this.senderName}<br />Company: ${this.senderCompany}<br />Mail: <a href='mailto:${this.senderMail}?subject=Food%20Display%20Configurator%20-%20Request%20Quotation'>${this.senderMail}</a><br />Phone number: ${this.senderPhone}</ul></p><p>Configuration:<br />${this.displayConfiguration()}<br />Best regards</p></div>`;
        let url =
          "https://schott.prod.apimanagement.eu20.hana.ondemand.com/fooddisplay/api/v1.0/mail";

        await axios.post(url, payload, headers);

        this.showNotification = true;
        this.notificationText = "Your request quotation has been sent.";
      } catch (e) {
        this.showNotification = true;
        this.notificationText =
          "There was an error in sending your request quotation. Please try again later.";
      }
    },
    sendMail () {
      this.generateMail();
      if (this.$store.getters.onlineTrackingEnabled) TrackingHelper.formTracking('submit', {
        product: `${this.$store.getters.coldroom === "LT" ? "Low Temperature":"Normal Temperature"} ${this.$store.getters.coldroomSystem} ${this.$store.getters.article}`.toLowerCase(),
        product_property: `color ${this.$store.getters.color.replace(/Standard/i, 'Light Gray')}, shelvings ${this.$store.state.shelvingsSwitch}`.toLowerCase()
      });
      /* eslint-disable no-console */
      console.log("Generated and sent mail");
      this.$emit("hide");
      this.notificationText = "";
      this.showNotification = false;

      /* eslint-disable no-console */
      // TODO: This consoles are returning errors
      /*
        console.log("component length: ", this.componentsMail.length);
        console.log("component0: ", this.componentsMail[0]);
        console.log("component1: ", this.componentsMail[1]);
      */

      // open confirmation page
      this.$router.push("/confirmation");
      console.log(this.$router)
    },
  },
};
</script>
